import { useCheckPermissions, useLoaders } from "@/shared"
import { SaveSolicitudEgresoPage } from "../../shared/saveSolicitudesPedidos"
import { PermissionsEnum } from "@/auth/interfaces"
import { useParams } from "react-router-dom"
import { useGetSolicitudPedido } from "@/shared/actions/erp"

export default function EditarSolicitudPedido() {
    useCheckPermissions(PermissionsEnum.api_change_solicitudegreso)
    const { id } = useParams()
    //console.log('id', id)
    const {
        data,
        isLoading
    } = useGetSolicitudPedido(id!)
    //console.log('dataP', data)
    useLoaders(isLoading)
    return <SaveSolicitudEgresoPage
        title="✏️ Editar Solicitud Pedido"
        editData={data?.data}
    />
}